"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusMessageT = exports.StatusMessage = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const status_data_js_1 = require("../../solarxr-protocol/rpc/status-data.js");
/**
 * An status is some kind of warning sent by the server, it's mainly made for
 * showing problems with the server and need attention from the user.
 */
class StatusMessage {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsStatusMessage(bb, obj) {
        return (obj || new StatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsStatusMessage(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new StatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    /**
     * The status ID
     */
    id() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    /**
     * This should be prioritized in the GUI in some way if true
     */
    prioritized() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    dataType() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : status_data_js_1.StatusData.NONE;
    }
    data(obj) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__union(obj, this.bb_pos + offset) : null;
    }
    static startStatusMessage(builder) {
        builder.startObject(4);
    }
    static addId(builder, id) {
        builder.addFieldInt32(0, id, 0);
    }
    static addPrioritized(builder, prioritized) {
        builder.addFieldInt8(1, +prioritized, +false);
    }
    static addDataType(builder, dataType) {
        builder.addFieldInt8(2, dataType, status_data_js_1.StatusData.NONE);
    }
    static addData(builder, dataOffset) {
        builder.addFieldOffset(3, dataOffset, 0);
    }
    static endStatusMessage(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createStatusMessage(builder, id, prioritized, dataType, dataOffset) {
        StatusMessage.startStatusMessage(builder);
        StatusMessage.addId(builder, id);
        StatusMessage.addPrioritized(builder, prioritized);
        StatusMessage.addDataType(builder, dataType);
        StatusMessage.addData(builder, dataOffset);
        return StatusMessage.endStatusMessage(builder);
    }
    unpack() {
        return new StatusMessageT(this.id(), this.prioritized(), this.dataType(), (() => {
            const temp = (0, status_data_js_1.unionToStatusData)(this.dataType(), this.data.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })());
    }
    unpackTo(_o) {
        _o.id = this.id();
        _o.prioritized = this.prioritized();
        _o.dataType = this.dataType();
        _o.data = (() => {
            const temp = (0, status_data_js_1.unionToStatusData)(this.dataType(), this.data.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })();
    }
}
exports.StatusMessage = StatusMessage;
class StatusMessageT {
    constructor(id = 0, prioritized = false, dataType = status_data_js_1.StatusData.NONE, data = null) {
        this.id = id;
        this.prioritized = prioritized;
        this.dataType = dataType;
        this.data = data;
    }
    pack(builder) {
        const data = builder.createObjectOffset(this.data);
        return StatusMessage.createStatusMessage(builder, this.id, this.prioritized, this.dataType, data);
    }
}
exports.StatusMessageT = StatusMessageT;
